// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-contents-index-tsx": () => import("/opt/build/repo/src/pages/contents/index.tsx" /* webpackChunkName: "component---src-pages-contents-index-tsx" */),
  "component---src-pages-contents-settings-tsx": () => import("/opt/build/repo/src/pages/contents/settings.tsx" /* webpackChunkName: "component---src-pages-contents-settings-tsx" */),
  "component---src-pages-index-tsx": () => import("/opt/build/repo/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

